import { Grid, GridItem, Stack, Text, useToast } from "@chakra-ui/react";
import { Section, Switcher } from "components";
import { API } from "config";
import { useDistributor } from "hooks";
import { useState } from "react";
import { useParams } from "react-router";

export default function Settings(){

    const toast = useToast()
    const params = useParams()
    const distributor = useDistributor(params?.id)
    
    const [ loading, setLoading ] = useState(false)

    const toggleActive = async () => {
        setLoading('active')

        try{
            await API.post(`/distributors/${distributor.data?.id}/active`, { value: !distributor.data?.active, _method: 'put' })
            toast({ title: 'Alteração realizada', status: 'success' })
            distributor.refetch()
        }catch(err){
            toast({ title: 'Não foi possível alterar agora. Tente novamente', description: err?.responser?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    const setOption = async (field, value = null) => {
        setLoading(field)

        try{
            await API.post(`/distributors/${distributor.data?.id}/options`, { field, value, _method: 'put' })
            toast({ title: 'Alteração realizada', status: 'success' })
            distributor.refetch()
        }catch(err){
            toast({ title: 'Não foi possível alterar agora. Tente novamente', description: err?.responser?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }

    return(
    <>
    <Section title="Configurações do núcleo" />
    
    <Stack spacing={4}>
        <Text children="Compras & Vendas:" fontSize="small" color="GrayText" />
        <Grid templateColumns="33% 33% 33%" gap={4}>
            <GridItem><Switcher value={distributor.data?.active} onClick={toggleActive} isDisabled={loading||distributor.isFetching} loading={loading==='active'} title="Liberar vendas" description="Permite que o núcleo apareça para os consultores." /></GridItem>
            <GridItem><Switcher value={distributor.data?.options?.allow_purchases} onClick={() => setOption('allow_purchases', !distributor.data?.options?.allow_purchases)} isDisabled={loading||distributor.isFetching} loading={loading==='allow_purchases'} title="Permitir compras" description="Permite que o núcleo faça novas compras de produtos." /></GridItem>
        </Grid>
    </Stack>
    </>
    )
}